//import apiClient from "services/_infra/apiClient";
import axios from 'axios';
/**
 * Fetches an AWARE image and returns a blob-backed object URL.
 * Callers are responsible for revoking the returned URL when no longer needed.
 * May only be needed for AWARE device images on develpoment environments.
 */
export const fetchStageImageObjectUrl = async (imgPath) => {
  if (!imgPath) return null;

  const stageImageUrl = buildStageImageUrl(imgPath, 'https://flashflood.info:8282');

  if (!stageImageUrl) return null;

  const response = await axios.get(stageImageUrl, {
    responseType: 'arraybuffer',
  });

  if (!response?.data) return null;

  const blob = new Blob([response.data], { type: 'image/jpeg' });
  return URL.createObjectURL(blob);
};

const buildStageImageUrl = (imgPath, baseUrl = 'https://flashflood.info:8282') => {
  if (!imgPath || typeof imgPath !== 'string') return null;

  const imgFileNameMatch = imgPath.match(/([^\/]+)$/);
  if (!imgFileNameMatch) return null;

  const imgFileName = imgFileNameMatch[1];

  const imeiMatch = imgFileName.match(/^([^_]+)_/);
  if (!imeiMatch) return null;

  const imei = imeiMatch[1];

  return `${baseUrl}/${imei}/${imgFileName}`;
};
